import {
  Panel,
  SPACING_16,
  SPACING_24,
  SpacingVertical,
  Title,
  TITLE_VARIANT_M
} from 'mailup-web-components'
import { campaignState } from 'Pages/Campaign/recoil/state/campaign'
import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useRecoilState } from 'recoil'
import RadioButtonChoose from './RadioButtonChoose'
import RadioButtonSource from './RadioButtonSource'

export const Frequency = () => {
  const intl = useIntl()

  const [{ CheckNumberOfNewContents }, setCheckNumberOfNewContents] =
    useRecoilState(campaignState)

  useEffect(() => {
    if (CheckNumberOfNewContents === 0) {
      setCheckNumberOfNewContents((prev) => ({
        ...prev,
        CheckNumberOfNewContents: 1
      }))
    }
  }, [CheckNumberOfNewContents])

  return (
    <>
      <Panel>
        <Title variant={TITLE_VARIANT_M}>
          {intl.formatMessage({
            id: 'Load.ContentsCampaignWizard.ChooseFrequencyTitle'
          })}
          {' *'}
        </Title>
        <SpacingVertical variant={SPACING_24} />
        <RadioButtonSource />
        <SpacingVertical variant={SPACING_16} />
        <RadioButtonChoose />
      </Panel>
    </>
  )
}
